import React from 'react';
const ClockIcon = () => (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.8511 9.78294L8.62023 8.10981V4.70163C8.62023 4.35894 8.34323 4.08194 8.00055 4.08194C7.65786 4.08194 7.38086 4.35894 7.38086 4.70163V8.41969C7.38086 8.61488 7.47258 8.79894 7.62873 8.91544L10.1074 10.7745C10.219 10.8581 10.3491 10.8984 10.4786 10.8984C10.6676 10.8984 10.8535 10.8135 10.975 10.6499C11.1808 10.3766 11.125 9.98806 10.8511 9.78294Z"
            fill="black"/>
        <path
            d="M8 0.370605C3.58853 0.370605 0 3.95914 0 8.37061C0 12.7821 3.58853 16.3706 8 16.3706C12.4115 16.3706 16 12.7821 16 8.37061C16 3.95914 12.4115 0.370605 8 0.370605ZM8 15.1313C4.27266 15.1313 1.23934 12.0979 1.23934 8.37061C1.23934 4.64326 4.27266 1.60995 8 1.60995C11.728 1.60995 14.7607 4.64326 14.7607 8.37061C14.7607 12.0979 11.7273 15.1313 8 15.1313Z"
            fill="black"/>
    </svg>
)
export default ClockIcon;

